import React, { useState, useEffect } from 'react';
import { FormBuilder } from 'react-formio';
import axios from 'axios';

const FormBuilderView = () => {
  const [formSchema, setFormSchema] = useState({});
  const [formName, setFormName] = useState('');
  const [roleId, setRoleId] = useState('');
  const [roles, setRoles] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const response = await axios.get(`${API_URL}/roles`);
        setRoles(response.data);
        if (response.data.length > 0) {
          setRoleId(response.data[0]._id); 
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRole();
  }, [API_URL]); 

  const handleFormChange = (schema) => {
    setFormSchema(schema);
  };

  const handleSave = async () => {
    if (!formName.trim()) {
      alert("Please enter a form name.");
      return;
    }

    if (!formSchema || !formSchema.components || formSchema.components.length === 0) {
      alert("Please design the form before saving.");
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/ems/forms`, {
        form_name: formName,
        schema: formSchema,
        // role_id: roleId,
      });
      alert('✅ Form saved to server!');
      console.log(response.data);
    } catch (error) {
      console.error('❌ Error saving form:', error);
      alert('Failed to save form to server');
    }
  };

  return (
    <div className="container mt-1">
      <h2 className="mb-4">Form Builder</h2>

      <div className="mb-3">
        <label htmlFor="formName" className="form-label">Form Name:</label>
        <input
          type="text"
          id="formName"
          className="form-control"
          value={formName}
          onChange={(e) => setFormName(e.target.value)}
          placeholder="Enter form name"
        />
      </div>

     

      <FormBuilder form={formSchema} onChange={handleFormChange} />

      <button className="btn btn-warning mt-4" onClick={handleSave}>
        💾 Save Form
      </button>
    </div>
  );
};

export default FormBuilderView;
